import axios from 'utils/axios';
import { AvailabilityStatus } from '../types/doctor';

export const updateSelfAvailability = (availability: AvailabilityStatus) => {
  return axios.put('/api/v1/doctors/me/availability', {
    availability,
  });
};
